/**
 * Validates whether a date string conforms to the ISO date format required by HTML date inputs
 * @param value - The date string to validate
 * @returns boolean - true if the value is empty or matches yyyy-MM-dd or yyyy-MM-ddThh:mm format
 */
export const isValidDateFormat = (value: string): boolean => {
  if (!value) return true;

  const dateRegex = /^\d{4}-\d{2}-\d{2}(T\d{2}:\d{2})?$/;
  return dateRegex.test(value);
};
